module.exports = __webpack_public_path__ + "img/contact-map.1545b696.png";